import { render, staticRenderFns } from "./my-camera.vue?vue&type=template&id=35e3c0d2&scoped=true&"
import script from "./my-camera.vue?vue&type=script&lang=js&"
export * from "./my-camera.vue?vue&type=script&lang=js&"
import style0 from "./my-camera.vue?vue&type=style&index=0&id=35e3c0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3c0d2",
  null
  
)

export default component.exports